import { MoonstarCreate } from '../Moonstar/MoonstarCreate';
import { MoonstarCreateForm } from '../Moonstar/MoonstarCreateForm';
import { SimpleStack } from '../Moonstar/SimpleStack';
import { KpiInputs } from './KpiInputs';

export const KpiCreate = () => (
  <MoonstarCreate redirect="list">
    <MoonstarCreateForm>
      <SimpleStack className="sm:w-full">
        <KpiInputs />
      </SimpleStack>
    </MoonstarCreateForm>
  </MoonstarCreate>
);
